import _ from '../../core/utils'

const MAP_CASE_AREA_CONFIG = {
    el: _.select( '.map__case-area' )
}

export default MAP_CASE_AREA_CONFIG